function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFEFDB",
  d: "M46.693 33.514C24.16 35.676 19.365 48.418 25.89 74.444c6.526 26.025 31.817 16.8 45.433 20.605 13.615 3.806 42.88 3.54 39.594-28.08-3.287-31.62-13.929-12.195-18.137-26.85-4.207-14.655-23.556-8.768-46.088-6.605z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFB300",
  d: "M120.146 34.03L83.873 60.41c-.276.196-24.372.196-24.648-.016L23 33.737a4.892 4.892 0 012.468-3.062l46.08-23.903 46.081 23.903a4.764 4.764 0 012.517 3.355z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6F6F6",
  d: "M100.776 2.096H42.322c-1.292 0-2.53.514-3.445 1.43a4.893 4.893 0 00-1.426 3.455v53.74h68.196V6.98a4.893 4.893 0 00-1.427-3.455 4.864 4.864 0 00-3.444-1.431z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFA000",
  d: "M120.146 34.03L83.873 60.41c-.276.196-24.373.196-24.649-.016L23.01 33.743c-.113.416-.17.845-.172 1.276V81.89a4.9 4.9 0 001.429 3.453 4.872 4.872 0 003.443 1.432h87.679a4.872 4.872 0 003.443-1.432 4.897 4.897 0 001.428-3.453V35.019a4.908 4.908 0 00-.112-.994l-.002.005h.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FB8C00",
  d: "M119.87 83.78a4.876 4.876 0 01-1.79 2.177 4.85 4.85 0 01-2.692.819h-87.68a4.849 4.849 0 01-2.692-.819 4.872 4.872 0 01-1.789-2.177l43.58-31.413a8.074 8.074 0 019.482-.001L119.87 83.78z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58220",
  d: "M71.548 44.436c8.968 0 16.238-7.291 16.238-16.285s-7.27-16.285-16.238-16.285c-8.967 0-16.237 7.291-16.237 16.285 0 8.993 7.27 16.285 16.237 16.285z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 0.628,
  d: "M68.505 32.99l-4.63-4.643a1.561 1.561 0 00-2.219-.01 1.574 1.574 0 00.01 2.225l5.698 5.715.002.001.012.013.006.006h0l.003.003a1.544 1.544 0 002.191-.008L81.29 24.546c.605-.607.614-1.59.008-2.198a1.544 1.544 0 00-2.19.009L68.504 32.99z"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 111.106,
  cy: 96.991,
  fill: "#F1823B",
  fillRule: "nonzero",
  rx: 2.999,
  ry: 3.009
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.937,
  cy: 8.605,
  fill: "#F1823B",
  fillRule: "nonzero",
  rx: 2.999,
  ry: 3.009
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 134.002,
  cy: 71.909,
  fill: "#FDB913",
  fillRule: "nonzero",
  rx: 5.998,
  ry: 6.019
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  fillRule: "nonzero",
  d: "M6.98 32.317l3.498-3.51a1.089 1.089 0 011.542 0l3.498 3.51a1.089 1.089 0 010 1.538l-3.498 3.51a1.089 1.089 0 01-1.542 0l-3.499-3.51a1.089 1.089 0 010-1.538z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FE9824",
  d: "M127.01 1.978l1.81 4.181 3.862 2.14a.903.903 0 01.001 1.578l-3.862 2.149-1.647 4.12a.903.903 0 01-1.652.055l-1.86-3.881-4.058-2.266a.903.903 0 01-.007-1.572l4.064-2.323L125.344 2a.903.903 0 011.665-.02zM6.85 84.898l1.157 2.669 2.565 1.42a.903.903 0 01.001 1.58l-2.566 1.427-1.055 2.641a.903.903 0 01-1.653.055l-1.185-2.474-2.72-1.519a.903.903 0 01-.008-1.572l2.728-1.558 1.071-2.65a.903.903 0 011.665-.02z"
}));

function SvgMailIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 100
  }, props), _ref);
}

export default SvgMailIllustration;